import { GET_FILTERS } from '../constants/actionNames';
import { IDispatchAction } from '../models/dispatch-action.interface';
import { getFilters } from '../services/filters.service';

export const fetchFilters = (): IDispatchAction<{}> => ({
  payload: getFilters(),
  type: GET_FILTERS,
});
